module.exports = __webpack_public_path__ + "img/portovelho_header.10ecae96.png";